(function() {
	'use strict';

	angular.module('widgets.buyer')
	.service('buyerStdMyPrsToFirmService', buyerStdMyPrsToFirmService);
	
	function buyerStdMyPrsToFirmService($http, URLS, leanFilterService, drilldownFunctionsService) {
		return {
			getMyPrsToFirm: getMyPrsToFirm,
			getDrilldownFilters: getDrilldownFilters,
			getReactDrilldownFilterString: getReactDrilldownFilterString
		};

		function getMyPrsToFirm() {
			var url = addQueryParam(URLS.host + URLS.myPRsToFirm,
				leanFilterService.getFactoryList(), leanFilterService.getQueryParamsObject(true), false);
			return $http.get(url);
		}

		function getReactDrilldownFilterString(type) {
			var comparatorsMap = leanFilterService.comparatorsMap;
			var day14 = moment.utc().add(-14, 'd').format('YYYY-MM-DD');
			var day7 = moment.utc().add(-7, 'd').format('YYYY-MM-DD');
			var day8 = moment.utc().add(-8, 'd').format('YYYY-MM-DD');

			var daysUntilPoFirm = 'daysUntilPOFirm';
			var orderCreationDate = 'orderCreationDate';
			var daysUntilProcurementLeadTime = 'daysUntilProcurementLeadTime';

			var drilldownFilters = [];

			if (type === 'over14') {
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(daysUntilPoFirm, comparatorsMap.lessThan, 0));
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(orderCreationDate, comparatorsMap.lessThan, day14));
			} else if (type === 'under14') {
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(daysUntilPoFirm, comparatorsMap.lessThan, 0));
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(orderCreationDate, comparatorsMap.between, day14, day8));
			} else if (type === 'under7') {
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(daysUntilPoFirm, comparatorsMap.lessThan, 0));
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(orderCreationDate, comparatorsMap.greaterThanOrEqual, day7));
			} else if (type === 'toFirm') {
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(daysUntilPoFirm, comparatorsMap.greaterThanOrEqual, 0));
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(daysUntilProcurementLeadTime, comparatorsMap.lessThanOrEqual, 0));
			} else {
				drilldownFilters.push(drilldownFunctionsService.makeRangeFilter(daysUntilProcurementLeadTime, comparatorsMap.lessThanOrEqual, 0));
			}

			return drilldownFunctionsService.makeDrilldownParamString(drilldownFilters, true);
		}

		function getDrilldownFilters(type) {
			var filtersObj = leanFilterService.getQueryParamsObject(true, true);
			filtersObj['drilldown'] = 1;
			filtersObj['factory'] = leanFilterService.getFactoryList();

			var day14 = moment.utc().add(-14, 'd').format('YYYY-MM-DD');
			var day7 = moment.utc().add(-7, 'd').format('YYYY-MM-DD');
			var day8 = moment.utc().add(-8, 'd').format('YYYY-MM-DD');
			
			switch (type) {
			case 'over14':
				filtersObj['daysUntilPoValueOne'] = 0;
				filtersObj['daysUntilPoComparator'] = 'lt';
				filtersObj['orderCreationDateValueOne'] = day14;
				filtersObj['orderCreationDateComparator'] = 'lt';
				break;
			case 'under14':
				filtersObj['daysUntilPoValueOne'] = 0;
				filtersObj['daysUntilPoComparator'] = 'lt';
				filtersObj['orderCreationDateValueOne'] = day14;
				filtersObj['orderCreationDateValueTwo'] = day8;
				filtersObj['orderCreationDateComparator'] = 'btw';
				break;
			case 'under7':
				filtersObj['daysUntilPoValueOne'] = 0;
				filtersObj['daysUntilPoComparator'] = 'lt';
				filtersObj['orderCreationDateValueOne'] = day7;
				filtersObj['orderCreationDateComparator'] = 'gte';
				break;
			case 'toFirm':
				filtersObj['daysUntilPoValueOne'] = 0;
				filtersObj['daysUntilPoComparator'] = 'gte';
				// also default
			default:
				filtersObj['daysUntilPLTValueOne'] = 0;
				filtersObj['daysUntilPLTComparator'] = 'lte';
				break;
			}
			return filtersObj;
		}
	}
})();